import axios from 'axios';
import api from './ApiAuthService';

export default class Canais {
  static async getCanais($channelId: number, $search: string) {
    try {
      let url = '/categories/' + $channelId;
      if ($search) {
        url += '?search=' + $search;
      }
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}